import React from 'react';

import { useServerData } from '@xingternal/hops';
import { redirectToLogin, useLoggedoutAction } from '@xingternal/pages-common';
import type { PopOverType } from '@xingternal/pop-over';
import type {  HeaderProps } from '../../types';


import { Menu } from '@xingternal/menu';

import List from './List';

type MenuContainerProps = Pick<HeaderProps, 'ctaType'> & {
  popOver: PopOverType;
  sharePage: () => void;
}

const MenuContainer = ({
  popOver,
  sharePage,
  ctaType,
} : MenuContainerProps) => {
  const { authenticated = false } = useServerData();

  const share = (closeMenu: () => void, sharePage: () => void, isLoggedIn: boolean) => {
    if (!isLoggedIn) {
      redirectToLogin('shareEntityPage');
    } else {
      closeMenu();
      sharePage();
    }
  };

  useLoggedoutAction(sharePage, 'shareEntityPage');

  return (
    <Menu
      onOutsideClick={popOver.handleHide}
      triggerRef={popOver.triggerRef}
      show={popOver.show}
    >
      <List
        sharePage={() => share(popOver.handleHide, sharePage, authenticated)}
        closePopUp={popOver.handleHide}
        ctaType={ctaType}
      />
    </Menu>
  );
};

export default MenuContainer;
